export default __webpack_public_path__ + "static/media/forward.882cf7e2.svg";